export enum Format {
  Day = 'dd',
  Month = 'MM',
  Year = 'yyyy'
};
